/**
 * Do not edit directly
 * Generated on Thu, 12 Jun 2025 21:02:51 GMT
 */

export const SPACING_XS = "0.25rem";
export const SPACING_SM = "0.5rem";
export const SPACING_MD = "1rem";
export const SPACING_LG = "1.5rem";
export const SPACING_XL = "2rem";
